import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin(async (nuxtApp) => {
  nuxtApp.provide('ymaps', window.ymaps3);
});
